export * from './wall-type-2.component'